import _ListItemIcon from "@material-ui/core/esm/ListItemIcon";
import _Menu from "@material-ui/core/esm/Menu";
import _IconButton from "@material-ui/core/esm/IconButton";
import _MenuItem from "@material-ui/core/esm/MenuItem";
import _ListItemText from "@material-ui/core/esm/ListItemText";
import _size from "lodash/size";
import _get from "lodash/get";
const _excluded = ["text", "onClick", "hidden", "disabled", "hiddenIcon"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var defaultProps = type && type.defaultProps, childrenLength = arguments.length - 3; if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) { for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3]; props.children = childArray; } if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {}); return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { messages } from "../TableMessages";
// material
import MoreVertIcon from '@material-ui/icons/MoreVert';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
// ----------------------------------------------------------------------
import { useStyles } from "./TableOptionsStyles";
import { actions } from "../types";
import { Option } from "./Option"; // import { messages as confirmationMessages } from 'components/ConfirmationDelete/ConfirmationDeleteMessages';

import { ConfirmationDelete, confirmationMessages } from '@octopy/react-modal';
import { useModal } from '@octopy/react-modal';

var _ref = /*#__PURE__*/_jsx(_ListItemIcon, {}, void 0, _jsx(EditIcon, {}));

var _ref2 = /*#__PURE__*/_jsx(_ListItemIcon, {}, void 0, _jsx(DeleteOutlineIcon, {}));

function TableOptions(props) {
  const _useIntl = useIntl(),
        f = _useIntl.formatMessage;

  const actions = props.actions,
        item = props.item,
        _props$dots = props.dots,
        dots = _props$dots === void 0 ? {} : _props$dots;
  const classes = useStyles();
  const ref = useRef(null);

  const _useState = useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        isOpen = _useState2[0],
        setIsOpen = _useState2[1];

  const _useModal = useModal(),
        handleOpenModal = _useModal.handleOpenModal;

  const customs = _get(actions, 'customs', {});

  const hasEdition = _size(_get(actions, 'edit', {})) > 0;
  const hasElimination = _size(_get(actions, 'deleteAction', {})) > 0;

  const openConfirmationModal = (item, callback, rest) => {
    handleOpenModal(_objectSpread({
      title: f(confirmationMessages.confirmationDeleteTitle),
      body: f(confirmationMessages.confirmationDeleteDescription),
      actionButtons: _jsx(ConfirmationDelete, {
        handleDelete: () => callback(item)
      })
    }, rest));
  };

  const handleClick = function handleClick(callback, item) {
    let deleteAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let modalConfig = arguments.length > 3 ? arguments[3] : undefined;
    setIsOpen(false);

    if (deleteAction) {
      return openConfirmationModal(item, callback, modalConfig);
    }

    if (callback) return callback(item);
  };

  const renderEditOption = (item, other) => {
    const text = other.text,
          _onClick = other.onClick,
          hidden = other.hidden,
          disabled = other.disabled,
          hiddenIcon = other.hiddenIcon;
    if (hidden) return null;
    return _jsx(_MenuItem, {
      className: classes.item,
      disabled: disabled,
      onClick: () => handleClick(_onClick, item)
    }, void 0, !hiddenIcon && _ref, _jsx(_ListItemText, {
      primary: _get(text, 'text', f(messages.editRegister)),
      primaryTypographyProps: {
        variant: 'body2'
      }
    }));
  };

  const renderDeleteOption = (item, other) => {
    const text = other.text,
          _onClick2 = other.onClick,
          hidden = other.hidden,
          disabled = other.disabled,
          hiddenIcon = other.hiddenIcon,
          rest = _objectWithoutProperties(other, _excluded);

    if (hidden) return null;
    return _jsx(_MenuItem, {
      className: classes.item,
      disabled: disabled,
      onClick: () => handleClick(_onClick2, item, true, rest)
    }, void 0, !hiddenIcon && _ref2, _jsx(_ListItemText, {
      primary: _get(text, 'text', f(messages.deleteRegister)),
      primaryTypographyProps: {
        variant: 'body2'
      }
    }));
  };

  return React.createElement(React.Fragment, null, React.createElement(_IconButton, {
    ref: ref,
    onClick: () => setIsOpen(true)
  }, React.createElement(MoreVertIcon, dots)), _jsx(_Menu, {
    open: isOpen,
    anchorEl: ref.current,
    onClose: () => setIsOpen(false),
    PaperProps: {
      className: classes.menu
    },
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, void 0, hasEdition > 0 && renderEditOption(item, _objectSpread({}, actions.edit)), hasElimination > 0 && renderDeleteOption(item, _objectSpread({}, actions.deleteAction)), Array.isArray(customs) ? customs.map((custom, index) => React.createElement(Option, _extends({
    item: item,
    key: index
  }, custom, {
    setIsOpen: setIsOpen
  }))) : customs && _size(customs) > 0 && React.createElement(Option, _extends({
    item: item
  }, customs, {
    setIsOpen: setIsOpen
  }))));
}

export { TableOptions };